import { RatioType } from '@/features/report-snapshots/interfaces';

export function formatPercentage(value: RatioType) {
  const ratio = value.numerator / value.denominator;

  if (!Number.isFinite(ratio)) {
    return '\u2014';
  }

  const percentage = (ratio * 100).toFixed(1).replace(/\.0$/, '');

  return `${percentage}%`;
}

export function fromFloatToPercentageString(value: number) {
  return `${(value * 100).toFixed(1).replace(/\.0$/, '')}%`;
}

export function toPercentString(val: number | string, decimalPlaces = 0) {
  if (typeof val === 'string') {
    val = parseFloat(val);
  }
  if (!isNumber(val)) {
    return `\u2014`; //em dash
  } else {
    return `${formatNumber(val, decimalPlaces)}%`;
  }
}

function formatNumber(number: number, decimalPlaces: number) {
  if (number <= 0.5 && number >= -0.5 && decimalPlaces === 0) {
    //For values less than half a percent we will have 1 place precision
    //parseFloat allows us to drop insignificant trailing zeros
    return parseFloat(number.toFixed(1));
  } else {
    return parseFloat(number.toFixed(decimalPlaces));
  }
}

function isNumber(n: number) {
  return !isNaN(n) && isFinite(n);
}
